import { Review, Data } from './types';


interface ReducerReviews{
  reviews: Review[];
  sorts: Data[];
  filters: Data[];
};
interface State{
  Reviews: ReducerReviews;
  isLoading: boolean;
  page: number;
  sort: string;
  filter: string[];
  selectedVariants: string[];
  reviewLeft: boolean,
};
export const defaultState: State = {
  Reviews: {},
  isLoading: true,
  page: 1,
  sort: '',
  filter: ['DEFAULT'],
  variants: [],
  reviewLeft: true,
};

export const ERROR_IN_FETCHING_REVIEW_DATA_API = 'Error in review data API.';
export const SORT = 'sort';
export const FILTERS = 'filters';
export const CHILDID = 'childIds';
export const DEFAULT = 'DEFAULT';
export const DOMAIN = 'domain';
